import { Box, Tooltip } from '@material-ui/core';
import { styled, makeStyles, withStyles } from '@material-ui/core/styles';

export const Logo = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  '& img': {
    display: 'block',
  },
});

export const TotalBalance = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  width: '22%',
});

export const MenuRight = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  minWidth: '90px',
  width: '38%',
});

export const HeaderTooltip = withStyles({
  tooltip: {
    fontSize: '11px',
  },
})(Tooltip);

export const useStyles = makeStyles({
  avatar: {
    width: '36px',
    height: '36px',
    fontSize: '14px',
    fontWeight: 700,
    color: '#ffee58',
    background: '#1E2141',
    border: '2px solid #ffffff22',
    marginLeft: '10px',
    marginRight: '5px',
    cursor: 'pointer',
    transition: 'border-color 0.2s ease',
    '&:hover': {
      borderColor: '#ffee58',
    },
  },
  container: {
    height: '60px',
    paddingRight: '9px',
    paddingLeft: '7px',
    maxWidth: '100%',
    position: 'fixed',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    background: '#2C325C',
    boxShadow: '0px 0px 10px #00000033',
    zIndex: 1,
  },
});
